import submitAction from './../diagram_logic.js';
import CourseController from '../../../course.controller';

class Diagram1Controller extends CourseController {

  constructor(courseService, diagramService, $scope) {
    'ngInject';

    super(courseService, diagramService, null, $scope);
    Object.assign(this, { diagramService, courseService });

    this.diagramId = 'diagram1d1-1';
    this.submitBtn = 'diagram1d1-1-submit';
    this.nextBtn = 'diagram1d1-2-next';
    this.diagramNumber = 1;
    this.amountCorrectAnswers = 1
    this.model = {
      boxOne: ''
    }
  }

  $postLink() {
    this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
  }
}

export default Diagram1Controller;



// WEBPACK FOOTER //
// ./client/app/components/diagrams/1/1d/diagram1/diagram1.controller.js